import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StandardApiResponse } from '@app/interfaces/standard-api-response';
import { BaseServerFilterEntity, ObjectResultModel } from '@app/models';
import { IEditService, IListService } from '@app/services';
import { IReceiptListRequestModel, IReceiptListingReportParamModel, IReceiptModel } from '../models';

@Injectable({ providedIn: 'root' })
export class ReceiptsService implements IListService, IEditService<IReceiptModel> {
	endpointBase = '/api/receipts';

	constructor(private readonly http: HttpClient) {}

	getListFiltered?: (lookupParams: BaseServerFilterEntity[]) => Observable<any>;

	getReceiptsList(requestModel: IReceiptListRequestModel): Observable<any> {
		return this.http.post(`${this.endpointBase}/receipts-list`, requestModel);
	}
	getReceiptLinesList(id: number): Observable<any> {
		return this.http.get(`${this.endpointBase}/receipt-lines-list/${id}`);
	}

	getById(id: number): Observable<any> {
		return this.http.get<StandardApiResponse<IReceiptModel>>(`${this.endpointBase}/${id}`);
	}

	getList(): Observable<any> {
		throw new Error('Method not implemented.');
	}
	updateEntity(entity: IReceiptModel): Observable<any> {
		return this.http.post<StandardApiResponse<ObjectResultModel>>(`${this.endpointBase}/update`, entity);
	}
	createEntity(entity: IReceiptModel): Observable<any> {
		return this.http.put<StandardApiResponse<ObjectResultModel>>(`${this.endpointBase}/create`, entity);
	}
	deleteEntity(Id: number): Observable<any> {
		return this.http.delete<any>(`${this.endpointBase}/${Id}`);
	}

	bulkDeleteEntities?(ids: number[] | string[]): Observable<any>;

	queueReceiptReport(id: number): Observable<any> {
		return this.http.post(`${this.endpointBase}/queue-receipt-report`, id);
	}

	queueReceiptListingReport(paramModel: IReceiptListingReportParamModel): Observable<any> {
		return this.http.post(`${this.endpointBase}/queue-receipt-listing-report`, paramModel);
	}
}
